import module from 'module';
import _ from 'lodash';

const templateUrl = require('./working-day-check.template.html');

module.component('workingDayCheck', {
  templateUrl: templateUrl,
  controller: function ($scope, $location, $interval, http, authentication,
                        ledgerActionTemplateCache, workingDayService, cashTransferCheckService,
                        commandAccessChecker, actionCommand, userCache) {

    let self = this;
    self.workingDayStatus = null;
    self.workingDayLocked = false;
    self.startDayAvailable = false;

    const cashTransferSub = cashTransferCheckService.toObservable()
      .subscribe(shouldBlock => this.blockActions = shouldBlock);

    const subscription = ledgerActionTemplateCache.toObservable()
        .combineLatest(commandAccessChecker.canExecuteCommandObservable(), (templates, canExecuteCommand) => {
          return _.map(templates, command => ({
              ...command,
              canExecute: canExecuteCommand(actionCommand.actionTypeToCommand(command.type))
          }));
        })
        .subscribe(templates => {
          self.startDayAvailable = false;
          // Search for START_DAY misc transaction
          const t = _.find(templates, {type: 'START_DAY'});
          if (t) {
            self.startDayAvailable = t.canExecute;
          }
    });

    self.$onInit = async () => {
      const users = await userCache.toPromise();
      const realUser = users.find(u => u.id === authentication.context.realUserId); // don't take phantom into the account
      self.isUserTechnical = realUser.technical;
    };

    self.logout = () => {
      authentication.logout();
    };

    const statusSub = workingDayService.toObservable()
      .subscribe(workingDay => {
        self.workingDayStatus = workingDay.status;
        self.workingDayLocked = _.includes(['CLOSED', 'BATCH_PROCESSING'], workingDay.status);
      });


    self.$onDestroy = () => {
      subscription.unsubscribe();
      statusSub.unsubscribe();
      cashTransferSub.unsubscribe();
    };
  }
});
